import React, { useState } from 'react';
import { Facebook, Twitter, Mail, Link2, Check, Share2 } from 'lucide-react';

const BTN = 'inline-flex items-center gap-2 rounded-full bg-white border border-splash-sand text-splash-green px-4 py-2.5 text-sm font-semibold btn-transition hover:border-splash-coral hover:text-splash-coralDark';

export default function ShareButtons({ url, text }) {
  const [copied, setCopied] = useState(false);
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(text);
  const links = [
    { id: 'facebook', label: 'Facebook', icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${u}` },
    { id: 'x', label: 'X', icon: Twitter, href: `https://twitter.com/intent/tweet?url=${u}&text=${t}` },
    { id: 'email', label: 'Email', icon: Mail, href: `mailto:?subject=${encodeURIComponent('Sponsor a swim lesson')}&body=${t}%20${u}` },
  ];

  const copy = async () => {
    await navigator.clipboard.writeText(url).catch(() => {});
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  const nativeShare = () => navigator.share({ title: 'Sponsor a Lesson', text, url }).catch(() => {});

  return (
    <div className="flex flex-wrap gap-2" data-testid="share-buttons">
      {typeof navigator !== 'undefined' && navigator.share && (
        <button type="button" onClick={nativeShare} data-testid="share-native" className={BTN}><Share2 className="w-4 h-4" /> Share</button>
      )}
      {links.map(({ id, label, icon: Icon, href }) => (
        <a key={id} href={href} target="_blank" rel="noreferrer" data-testid={`share-${id}`} className={BTN}>
          <Icon className="w-4 h-4" /> {label}
        </a>
      ))}
      <button type="button" onClick={copy} data-testid="share-copy-link" className={BTN}>
        {copied ? <Check className="w-4 h-4 text-splash-teal" /> : <Link2 className="w-4 h-4" />} {copied ? 'Copied!' : 'Copy link'}
      </button>
    </div>
  );
}
